import { useEffect, useMemo, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import { useTranslation } from 'react-i18next';
import { toTitleCase } from '@shared/utils/utilsOld';
import UtmsButton from '@shared/components/ui/UtmsButton';

const ModalDuplicate = ({ open, setOpen, object, initialName, handleSubmit, label, title }) => {
    const { t } = useTranslation();
    const initialNameValue = useMemo(() => {
        return `${initialName}(Copy)`;
    }, [initialName]);
    const [name, setName] = useState(initialNameValue);
    const [error, setError] = useState('');

    useEffect(() => {
        setName(initialNameValue);
    }, [initialNameValue]);

    const handleClose = () => {
        setOpen(false);
        setError('');
        setName(initialNameValue);
    };

    const handleSubmitButton = () => {
        handleClose();
        handleSubmit(name);
    };

    const handleNameTextFieldChange = (e) => {
        setName(e.target.value);
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle variant="h4">{title || `${t('duplicate')} ${object || t('object')}`}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    error={Boolean(error)}
                    helperText={error}
                    sx={{ width: '400px', mt: 1 }}
                    label={label || toTitleCase(object)}
                    variant="outlined"
                    placeholder={`${t('type_new_name')}...`}
                    size="small"
                    value={name}
                    onChange={handleNameTextFieldChange}
                />
            </DialogContent>
            <DialogActions>
                <UtmsButton onClick={handleSubmitButton} autoFocus>
                    {t('duplicate')}
                </UtmsButton>
                <UtmsButton onClick={handleClose} color="secondary">
                    {t('cancel')}
                </UtmsButton>
            </DialogActions>
        </Dialog>
    );
};

export default ModalDuplicate;
